module.exports = {"522328001":"招堤街道","522328002":"栖凤街道","522328003":"钱相街道","522328101":"龙广镇","522328102":"德卧镇","522328103":"万峰湖镇","522328104":"木咱镇","522328105":"洒雨镇","522328106":"普坪镇","522328107":"龙山镇","522328110":"新桥镇","522328111":"海子镇","522328112":"笃山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522328.json
// module id = 2509
// module chunks = 0